import styled from 'styled-components/macro';
import { keyframes } from 'styled-components';
import 'react-phone-number-input/style.css';

export const Container = styled.div`
  width: 100%;
  position: relative;
  opacity: ${({ disabled }) => (disabled ? '.3' : '1')};
  @media (max-width: ${({ theme }) => `${theme.breakpoints.sm}px`}) {
    ${({ type }) => type === 'checkbox' && 'margin-bottom:20px;'}
  }
`;

export const Label = styled.label`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.label}px;
  width: 100%;
  opacity: ${({ shouldShow }) => (shouldShow ? 1 : 0)};
  transition: opacity 0.3s;
`;

const flashyEntranceKeyframe = keyframes`
  0%{
    background-color:transparent;
  }
  50%{
    background-color:#FFBABA;
  }
  100%{
    background-color:transparent;
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  height: ${({ type }) => (type === 'checkbox' ? 'auto' : '30px')};
  border-bottom: solid 1px
    ${({ theme, errorColor }) => (errorColor ? theme.red : theme.dark)};
  display: flex;
  align-items: center;
  ${({ type }) => type === 'checkbox' && 'border-bottom:0;'}
  animation: ${({ flashyEntrance }) =>
    flashyEntrance ? flashyEntranceKeyframe : ''}
    0.5s ease-out;

  svg {
    width: 20px;
    margin-left: 5px;
  }
`;

export const Input = styled.input`
  font-family: ${({ theme }) => theme.primaryFontMedium};
  font-size: ${({ theme }) => theme.paragraph}px;
  width: ${({ type }) => (type === 'checkbox' ? '20px' : '100%')};
  color: ${({ theme }) => theme.dark};
  background-color: transparent;
  height: ${({ type }) => (type === 'checkbox' ? '20px' : '100%')};
  ${({ type }) => type === 'checkbox' && 'margin:5px;'}
  border-style: none;
  line-height: 30px;
  padding-left: 10px;
  ${({ type, checkboxError, theme }) =>
    type === 'checkbox' && checkboxError && `outline: 1px solid ${theme.red};`}
`;

export const InputTel = styled.div`
  width: 100%;
  & > div {
    display: flex;
    flex-direction: row-reverse;
    flex-grow: 1;
    width: 100%;
    input {
      margin-left: 6px;
      border: none;
      background-color: transparent;
      font-family: ${({ theme }) => theme.primaryFontMedium};
      font-size: ${({ theme }) => theme.paragraph}px;
      padding-right: 9px;
    }
    .PhoneInputCountryIcon {
      margin-right: 4px;
    }
    .PhoneInputCountrySelectArrow {
      width: 7px;
      font-weight: bold;
      height: 7px;
      border-bottom: solid 2px ${({ theme }) => theme.dark};
      border-right: solid 2px ${({ theme }) => theme.dark};
      opacity: 1;
    }
  }
`;
